// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"GalleryGrid_gridContainer__z8RCu","header":"GalleryGrid_header__mlFc5","content":"GalleryGrid_content__qJ7_t","mobileView":"GalleryGrid_mobileView__PXBJL"};